import { ICON_CS } from '@repo/assets';
import { Input } from '@repo/components';
import { EMAIL } from '@repo/constants';
import { Button, Icon } from '@successmode-ktp/kui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { validateEmail } from '@repo/utils';

type Props = {
  onBackPage: () => void;
  onNext: (v: string) => void;
  value?: string;
  lang: 'KOR' | 'ENG';
};

export const Email = ({ onBackPage, onNext, value, lang }: Props) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<{ message: string } | null>(null);

  useEffect(() => {
    if (value) {
      setEmail(value);
    }
  }, [value]);

  const handleNext = () => {
    if (validateEmail(email)) {
      onNext(email);
    } else {
      setError({ message: EMAIL[lang].error });
    }
  };

  return (
    <>
      <TitleWrapper>
        <button type='button' onClick={onBackPage}>
          <Icon.ChevronLeft fillColor='#A7A7A7' />
        </button>
        <Title>
          <IconCs src={ICON_CS} alt='' />
          {EMAIL[lang].title}
        </Title>
        <Box />
      </TitleWrapper>
      <ExplainWrapper>
        <ExplainTitle>{EMAIL[lang].subTitle}</ExplainTitle>
        <ExplainText>{EMAIL[lang].contents}</ExplainText>
      </ExplainWrapper>
      <InputWrapper>
        <Input
          type='email'
          label={EMAIL[lang].label}
          placeholder={EMAIL[lang].placeholder}
          isRequired
          onChange={(e) => {
            setEmail(e.target.value);
            setError(null);
          }}
          value={email}
          error={error}
        />
      </InputWrapper>
      <ButtonWrapper>
        <Button type='button' style={{ flex: 2 }} onClick={handleNext}>
          {EMAIL[lang].btnNext}
        </Button>
      </ButtonWrapper>
    </>
  );
};

const TitleWrapper = styled.h6`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 20px;
  width: 100%;
  border-bottom: 1px solid #f4f4f4;
`;

const Box = styled.div`
  width: 24px;
  height: 24px;
`;

const Title = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #030303;
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.4px;
`;

const IconCs = styled.img`
  display: block;
  width: 24px;
  height: 24px;
`;

const ExplainWrapper = styled.div`
  padding: 16px 20px 24px;
  width: 100%;
`;

const ExplainTitle = styled.strong`
  display: block;
  color: var(--KTP-Color-Mono-80, #3a3b3e);
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.6px;
  margin-bottom: 8px;
`;

const ExplainText = styled.p`
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const InputWrapper = styled.div`
  padding: 0 20px;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 20px 20px 40px;
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #fff;
  box-shadow: 0px -3px 6px 0px rgba(203, 203, 203, 0.25);
`;
